import { fetchAWSBucketImages } from 'Utils';
import { CameraAlt } from '@mui/icons-material';
import { Photos } from 'Pages';

const params = {
  Bucket: 'luke-weathington-site-assets',
  Prefix: 'images/',
};

const PhotosContent = {
  title: 'Photos',
  getImages: () => fetchAWSBucketImages(params),
  icon: <CameraAlt />,
  path: '/media/photos',
  subMenu: true,
  menuIndex: 2,
  element: <Photos />,
};

export default PhotosContent;
